import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { ToasterService, ToasterType } from '@tt-chvac/core';
import { FeatureEnum, OfficeSelectorService } from '@tt-chvac/core-sales-web';
import { Observable } from 'rxjs';
import { AuthorizeAccessService } from '../services/authorize-access.service';
import { GlobalFilterService } from '../services/global-filter.service';

@Injectable({
  providedIn: 'root',
})

export class AuthorizeGuard  {

  constructor(
    private authorizeAccessService: AuthorizeAccessService,
    private router: Router,
    private toasterService: ToasterService,
    private officeSelectorService: OfficeSelectorService,
    private globalFilterService: GlobalFilterService) {
  }

  /**
   * Read only user should not navigate to other screen except project screen
   * @param route as ActivatedRouteSnapshot
   * @param state RouterStateSnapshot
   * @returns activate as Observable<boolean>
   */
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> {
    const drAddressId = +route.paramMap.get('drAddressId');
    if (localStorage.getItem('userHasSalesOffice') == null) {
      this.officeSelectorService.getOfficeSelectorList().subscribe((data) => {
        data = data ?? [];
        localStorage.setItem('userHasSalesOffice', data.length > 0 ? 'true' : 'false');
        this.handelReadOnlyUser(drAddressId);
      });
    } else {
      this.handelReadOnlyUser(drAddressId);
    }
    return true;
  }

  /**
   * Checks if the user is read-only and redirects them with an error message
   * @param drAddressId as Specified drAddressId
   * @returns Allow access if the user is not read-only
   */
  handelReadOnlyUser(drAddressId: number): boolean | Observable<boolean> {
    if (this.authorizeAccessService.isReadOnlyUser(FeatureEnum.CreditProject)) {
      return new Observable<boolean>(obs => {
        this.toasterService.setToaster(ToasterType.ERROR, 'You are not authorized to view this page currently');
        this.router.navigate(['/projects/' + drAddressId]);
      });
    }
    return true;
  }
}